import type { InvoiceLineItemSearchResponse } from '@techgitter/contracts';
import { buildSearchParams } from '../utils/lineItemExplorer';
import type { LineItemExplorerFilters } from '../utils/lineItemExplorer';

const API_BASE_URL = '/api';

/**
 * GET /api/invoice-line-items — invoice lines across every invoice.
 * A 400 carries a message meant for the user (e.g. "Searching all customers
 * needs at least one keyword"), so it is surfaced as-is.
 */
export async function searchInvoiceLineItems(
  filters: LineItemExplorerFilters,
  signal?: AbortSignal,
): Promise<InvoiceLineItemSearchResponse> {
  const response = await fetch(
    `${API_BASE_URL}/invoice-line-items?${buildSearchParams(filters)}`,
    { method: 'GET', headers: { Accept: 'application/json' }, signal },
  );

  if (!response.ok) {
    let message = `Search failed: ${response.status} ${response.statusText}`;
    if (response.status === 400) {
      try {
        const body = await response.json();
        if (body?.error) message = body.error;
      } catch {
        // keep the generic message
      }
    }
    throw new Error(message);
  }
  return response.json();
}
